import React from "react";
import makeCarousel from "react-reveal/makeCarousel";
import Slide from "react-reveal/Slide";
import styled from "styled-components";

// Archetype colors mapped by name
const archetypeColors = {
  Innocent: "#1a7349",
  Sage: "#35b276",
  Explorer: "#a8cc67",
  Hero: "#fde900",
  Rebel: "#f1ac2a",
  Magician: "#f08229",
  Everyman: "#e70d7e",
  Joker: "#ed2f3e",
  Lover: "#9f228f",
  Creator: "#372b93",
  Ruler: "#0474bc",
  Caregiver: "#00a6df",
};

// Generic archetype block
const ArchetypeBlock = styled.div`
  height: 8px;
  width: 100%;
  background-color: ${(props) => props.color};
  @media screen and (max-width: 768px) {
    height: 8px;
  }
`;

// Layout components
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 8px;
  background-color: #000;
`;

const BlocksContainer = styled.div`
  display: flex;
  justify-content: space-between;
  z-index: 1;
  width: 100%;
`;

const Block = styled.div`
  width: 33.33%;
  text-align: center;
`;

// Archetype groups
const archetypeGroups = [
  ["Creator", "Ruler", "Caregiver"],
  ["Innocent", "Sage", "Explorer"],
  ["Hero", "Rebel", "Magician"],
  ["Joker", "Everyman", "Lover"],
];

const TwelveJungianCarouselLeft = () => {
  const CarouselUI = ({ children }) => <Container>{children}</Container>;
  const Carousel = makeCarousel(CarouselUI);

  return (
    <Carousel defaultWait={1500} maxTurns={100}>
      {archetypeGroups.map((group, idx) => (
        <Slide key={idx} left>
          <BlocksContainer>
            {group.map((name) => (
              <Block key={name}>
                <ArchetypeBlock color={archetypeColors[name]} />
              </Block>
            ))}
          </BlocksContainer>
        </Slide>
      ))}
    </Carousel>
  );
};

export default TwelveJungianCarouselLeft;
